<template>
  <div>
    <!-- Table view (hidden on mobile) -->
    <div v-if="isLoading" class="flex justify-center items-center py-20">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
    </div> 
    <div v-else-if="!isLoading && investors.length > 0" class="hidden md:block overflow-x-auto">
      <table  class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">S/N</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Investor Name</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Industry</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(investor, index) in investors" :key="investor.investorId">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ index + 1 }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ investor.name }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ investor.email }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ investor.industry || 'N/A' }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ investor.isApproved ? 'Approved' : 'Pending Approval' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-blue-500">
              <a v-if="!investor.isApproved" href="#" @click.prevent="approveInvestor(investor)">Approve</a> |
              <a v-if="!investor.isApproved" href="#" class="text-red-500" @click.prevent="denyInvestor(investor)">Deny</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="!isLoading && investors.length === 0" class="text-center py-16">
      <p class="mx-auto bg-primaryLight px-2 py-24 border border-grayLight rounded-[16px]">
        No investors found.
      </p>
    </div>
    <!-- Card view (visible only on mobile) -->
    <div class="md:hidden">
      <div v-for="(investor, index) in investors" :key="investor.investorId" class="bg-white rounded-lg shadow mb-4 p-4 border border-gray-200">
        <div class="flex justify-between items-center mb-2">
          <div class="font-medium text-gray-800">{{ investor.name }}</div>
          <div class="text-sm text-gray-500">{{ investor.industry || 'N/A' }}</div>
        </div>
        <div class="mb-2 text-sm text-gray-700">{{ investor.email }}</div>
        <div class="grid grid-cols-2 gap-2 text-xs text-gray-500">
          <div>
            <span class="font-medium">S/N:</span> {{ index + 1 }}
          </div>
          <div>
            <span class="font-medium">Status:</span> {{ investor.isApproved ? 'Approved' : 'Pending Approval' }}
          </div>
          <div v-if="!investor.isApproved">
            <a href="#" class="text-blue-500" @click.prevent="approveInvestor(investor)">Approve</a> |
            <a href="#" class="text-red-500" @click.prevent="denyInvestor(investor)">Deny</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvestorTable',
  props: {
    investors: {
      type: Array,
      required: true,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    approveInvestor(investor) {
      this.$emit('approve-investor', investor);
    },
    denyInvestor(investor) {
      this.$emit('deny-investor', investor);
    }
  }
};
</script>

<style scoped>
/* Any additional custom styles can go here */
</style>
